<template>
    <div>
        <!-- Sidebar открытого умк -->
        <vs-sidebar click-not-close parent="#todo-app" :hidden-background="true" class="full-vs-sidebar email-view-sidebar items-no-padding" v-model="isEmcSidebarActive" position-right>
            <div v-if="getEmc" class="mail-sidebar-content px-0 sm:pb-6 h-full">
                <div class="flex flex-wrap items-center email-header justify-between md:px-8 px-6 sm:pb-2 sm: pt-6 d-theme-dark-bg">
                    <div class="flex mb-4">
                        <!-- заголовок умк, кнопка закрытия -->
                        <div class="flex items-center">
                            <feather-icon :icon="$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'" @click="$emit('closesidebar')" class="cursor-pointer mr-4" svg-classes="w-6 h-6"></feather-icon>
                            <h4>{{ getEmc.name }}</h4>
                        </div>
                    </div>
                </div>
                <component :is="'VuePerfectScrollbar'" class="scroll-area-emcfull-content md:px-8 md:pb-8 pt-4 px-6 pb-6" :settings="settings" :key="$vs.rtl">
                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <vx-card class="px-4">
                                <div class="vx-row">
                                    <div class="vx-col pb-2 w-full border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid flex justify-between flex items-center">
                                        <!-- имя автора, язык и дисциплина карточки -->
                                        <div class="flex items-center">
                                            <div class="flex flex-col">
                                                <vs-row vs-sm="12" class="md:hidden">
                                                    <vs-col  vs-sm="12">
                                                        <vs-chip  class="my-1 " color="primary">{{ getEmc.discipline_name }}</vs-chip>
                                                    </vs-col>
                                                    <vs-col  vs-sm="12">
                                                        <vs-chip v-if="itemLang(getEmc)" class="lang_chip my-1"  color="warning">{{ itemLang(getEmc) }}</vs-chip>
                                                    </vs-col>
                                                </vs-row>
                                                <vs-row vs-lg="12" class="hidden sm:inline-flex">
                                                    <vs-chip  class="mr-2" color="primary">{{ getEmc.discipline_name }}</vs-chip>
                                                    <vs-chip v-if="itemLang(getEmc)" class="lang_chip"  color="warning">{{ itemLang(getEmc) }}</vs-chip>
                                                </vs-row>
                                                <h5>{{ getEmc.author_name }}</h5>
                                            </div>
                                        </div>

                                        <!-- Время и дата создания УМК -->
                                        <div class="flex flex-col justify-end emc_view_date">
                                            <span class="text-right">{{ $moment(getEmc.created).format('HH:mm') }}</span>
                                            <div class="flex justify-end mt-1">
                                                <span class="text-right">{{ $moment(getEmc.created).format('LL') }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Описание УМК -->
                                <div class="vx-row">
                                    <div class="vx-col w-full mt-5 mb-4">
                                        <div class="text-sm mb-1">{{$t('description')}}</div>
                                        <div class="mail__content break-words" v-html="getEmc.description"></div>
                                    </div>
                                </div>

                                <!-- Список файлов умк -->
                                <div class="vx-row" v-if="getEmc.files.length">
                                    <div class="vx-col w-full mt-4 mb-4">
                                        <div class="text-sm mb-1">{{$t('download_files')}}</div>
                                        <div class="files_content">
                                            <div class="file_item mb-4" v-for="file in getEmc.files" :key="file.uid">
                                                <a class="flex items-center" download :href="file.file.path">
                                                    <i class="feather icon-download mr-3"></i>
                                                    <span>{{file.name}}</span>
                                                </a>
                                                <vs-collapse-item v-if="file.description">
                                                    <div slot="header">
                                                        {{$t('file_description')}}
                                                    </div>
                                                    {{file.description}}
                                                </vs-collapse-item>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Кнопка скачать архивом -->
                                <div class="pb-2" v-if="getEmc.files.length > 1">
                                    <a
                                        :href="`/api/v1/emc/emc/emc_arcive/?emc_uid=${openEmcId}`"
                                        download
                                        class="archive_link vs-component vs-button vs-button-success vs-button-filled">
                                        {{$t('download_archive')}}
                                    </a>
                                </div>

                                <div v-if="showButtons" class="flex mt-4">
                                    <vx-tooltip poition="left" :text="$t('delete')">
                                        <vs-button icon="delete" color="danger" @click="deleteEmc"></vs-button>
                                    </vx-tooltip>

                                    <vx-tooltip position="right" :text="$t('edit')">
                                        <vs-button class="ml-2" icon="edit" @click="editEmc"></vs-button>
                                    </vx-tooltip>


                                </div>
                            </vx-card>
                        </div>
                    </div>
                </component>
            </div>
        </vs-sidebar>
    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
    props: {
        openEmcId: {
            required: true,
            type: String
        },
        isEmcSidebarActive: {
            type: Boolean,
            required: true
        },
        mailFilter: {
            type: String
        }
    },
    data () {
        return {
            showThread: false,
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.50
            }
        }
    },
    watch: {
        isEmcSidebarActive (value) {
            if (!value) {
                this.$emit('closesidebar')
                setTimeout(() => {
                    this.showThread = false
                }, 500)
            }
        }
    },
    methods: {
        itemLang(item) {
            // Подставляем локализацию для поля язык
            if(this.$i18n.locale === 'ru') return item.language_name
            else return item[`language_name_${ this.$i18n.locale }`]
        },
        deleteEmc(){

            this.$emit('deleteEmc', this.getEmc)
        },
        editEmc(){
            this.$emit('editEmc', this.getEmc)
        }
    },
    computed: {
        showButtons(){
            return  this.$store.state.user.user.profileId  === this.getEmc.author_uid
        },
        getEmc() {
            // Получаем открытый УМК
            return this.$store.getters['emc/getEmcByUid'](this.openEmcId)
        },
        scrollbarTag () { return this.$store.getters.scrollbarTag }
    },
    components: {
        VuePerfectScrollbar
    }
}

</script>

<style lang="scss">
.lang_chip{
    .text-chip{
        text-transform: capitalize;
    }
}
.files_content{
    .vs-collapse-item--header{
        padding: 0px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 13px;
        .icon-header{
            position: relative;
            right: inherit;
            top: initial;
            margin: 0px;
            transform: initial;
        }
    }
    .vs-collapse{
        padding: 0px;
    }
    .vs-collapse-item--content{
        background-color: #f8f8f8;
        border-radius: 5px;
        margin-top: 8px;
    }
    .open-item{
        .icon-header{
            transform: rotate(180deg)!important;
        }
    }
}
.scroll-area-emcfull-content{
    position: relative;
    width: 100%;
    height: calc(100% - 35px);
    .archive_link{
        color: #ffffff!important;
    }
}
@media only screen and (max-width: 900px) {
    .scroll-area-emcfull-content{
        padding-left: 1rem !important;
        padding-right: 1rem !important;
    }
    .email-view-sidebar{
        .emc_view_date{
            .justify-end {
                justify-content: flex-start!important;
            }
            .text-right{
                text-align: left!important;
            }
        }
        .vx-card__collapsible-content{
            margin: 0 -20px;
        }
        .con-vs-chip{
            .text-chip{
                font-size: 10px;
            }
        }
        .email-header{
            h4{
                font-size: 15px;
            }
        }
        .vx-card__body{
            .d-theme-border-grey-light{
                display: block!important;
            }
        }
    }
}
</style>
